<template lang="pug">
section.tabela-cadastro-pessoas
    h3.tabela-cadastro-pessoas__title Lista de personas registradas

    el-table(
        :data='pessoas'
        style='width: 100%'
        @selection-change='handleSelectionChange'
    )
        el-table-column(
            v-if='removendo'
            type='selection'
            width='45'
            align='center'
        )

        el-table-column(
            prop='nomeRazaoSocial'
            label='Nombre o Razón Social'
            min-width='220'
        )

        el-table-column(
            prop='cuit'
            label='CUIT'
            width='160'
        )

        el-table-column(
            prop='email'
            label='E-mail'
            min-width='200'
        )

        el-table-column(
            prop='telefone'
            label='Teléfono'
            width='150'
        )

        el-table-column(
            prop='provincia'
            label='Provincia'
            width='150'
        )
            template(slot-scope='scope')
                span {{ scope.row.provincia.nome }}

        el-table-column(
            prop='departamento'
            label='Departamento'
            width='150'
        )
            template(slot-scope='scope')
                span {{ scope.row.departamento.nome }}

        el-table-column(
            prop='localidade'
            label='Localidad'
            min-width='240'
        )
            template(slot-scope='scope')
                span {{ scope.row.localidade.nome }}

        el-table-column(
            prop='idCliente'
            label='ID del Cliente'
            width='150'
        )

        template(slot='empty')
            el-empty(description='Ninguna persona registrada')
</template>

<script>
export default {
    name: 'TabelaCadastroPessoas',

    props: {
        pessoas: {
            type: Array,
            required: true
        },
        removendo: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            pessoasSelecionadas: []
        };
    },

    methods: {
        handleSelectionChange(selecionadas) {
            this.pessoasSelecionadas = selecionadas;
            this.$emit('pessoasSelecionadas', selecionadas);
        }
    }
};
</script>

<style lang="scss" scoped>
.tabela-cadastro-pessoas {
    &__title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
    }

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
    }

    &__rodape {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        font-size: 13px;
        color: #606266;
    }
}
</style>
